module.exports = __webpack_public_path__ + "media/images/order-87346d66056df05c9900a4a9631ea13c.png";